export default __webpack_public_path__ + "static/media/mobile-bro.a253d420.svg";